import { useState } from 'react';
import banner_back from '../../assets/home/banner-back.png';
import banner_front from '../../assets/home/banner-front.png';
import PilotRequest from '../Forms/PilotRequest';

export default function HomeBanner() {
    const [showPilotForm, setShowPilotForm] = useState(false);
    const [showDemoForm, setShowDemoForm] = useState(false);
    
    return (
        <div className="w-[100%] h-[780px] xl:h-[505px] ">
            {showPilotForm && <PilotRequest title="пилот" onClose={() => setShowPilotForm(false)} />}
            {showDemoForm && <PilotRequest title="демо" onClose={() => setShowDemoForm(false)} />}

            <div className='w-full relative'>
                <div className="w-full xl:w-[1512.25px] left-0 xl:left-[970.05px] top-[-369.97px] absolute opacity-50">
                    <div className="w-full xl:w-[1018.53px] h-auto xl:h-[1021.44px] left-[-50px] top-0 xl:top-[723.19px] absolute origin-top-left rotate-[-45.24deg] bg-gradient-to-l from-[#864934] via-[#bb865b] to-[#ffd38e] rounded-[103.47px]" />
                    <div className="w-full xl:w-[1018.53px] h-auto xl:h-[1021.44px] left-[-133.34px] top-0 xl:top-[723.19px] absolute origin-top-left rotate-[-45.24deg] opacity-70 bg-gradient-to-r from-[#864934] to-[#ffd38e] rounded-[103.47px]" />
                    <div className="w-full xl:w-[1018.53px] h-auto xl:h-[1021.44px] left-0 xl:left-[63.64px] top-0 xl:top-[723.19px] absolute origin-top-left rotate-[-45.24deg] bg-gradient-to-l from-[#864934] via-[#bb865b] to-[#ffd38e] rounded-[103.47px] " />
                </div>
            </div>
            <div className='relative z-[5] px-4 sm:px-16 py-3 xl:py-[101px]'>
                <div className='container mx-auto'>
                <div className="flex w-full flex-col xl:flex-row justify-between items-center xl:items-start">

                    <div className="h-auto xl:h-[382.82px] w-full max-w-[475px] xl:max-w-[720px] mt-[20px] xl:mt-[-28px] flex-col justify-start items-start gap-[40px] xl:gap-[40.38px] inline-flex">
                        <div className="self-stretch text-white text-[18px] xs:text-[20px] leading-normal xl:text-[32px] xl:leading-[45.21999999999999px] font-bold font-['Open Sans'] z-10">
                            Полная прозрачность всех <br className='xl:block'/> бизнес-процессов и ИТ-систем <br className='xl:hidden'/>
                            с 
                            <br className='hidden xl:block'/> использованием искусственного <br className='hidden xl:block'/> интеллекта.
                        </div>
                        <div className="self-stretch h-auto xl:h-[70px] text-[#ffcda1] text-[16px] xl:text-xl font-medium lg:font-bold font-['Open Sans'] xl:mt-[-15px] mb-[10px] xl:mb-0 z-10">
                            С нами ваши системы работают <br className=' md:hidden'/>
                            как часы, а <br className='hidden xl:block'/> проблемы решаются <br className='md:hidden'/>
                            до их появления.
                        </div>
                        <div className="w-full justify-center items-center xl:justify-start xl:items-start gap-[20px] xl:gap-2.5 flex flex-col lg:flex-row">
                            <button 
                                onClick={() => {
                                    setShowDemoForm(true)
                                }}
                                className="flex justify-center items-center bg-gradient-to-r from-[#6082a0] to-[#e55961] rounded-[20px] overflow-hidden text-white text-[16px] xl:text-xl font-bold font-['Open Sans'] hover:from-[#e55961] hover:to-[#e55961] transition-colors duration-300 w-full max-w-[320px] xs:w-[320px] xl:w-[252px] h-[47px] z-10"
                            >
                                Запросить демо
                            </button>
                            <button 
                                onClick={() => {
                                    setShowPilotForm(true)
                                }}
                                className="flex justify-center items-center bg-white/20 rounded-[20px] border border-white text-white text-[16px] xl:text-xl font-bold font-['Open Sans'] hover:bg-white hover:text-[#544a28] transition-colors duration-300 w-full max-w-[320px] xs:w-[320px] xl:w-[252px] h-[47px] z-10"
                            >
                                Заявка на пилот
                            </button>
                        </div>
                    </div>

                    <div className="w-full max-w-[600px] h-[560px] xl:h-[948px] lg:mt-[40px] xl:mt-[-178px] pb-[267px] flex items-center justify-center relative xxl:inline-flex  xl:max-w-full overflow-hidden ">
                        <img className="w-xl:w-auto h-[189px] lg:h-[231px] xl:h-[353px] rounded-[18px] opacity-50 left-[10px] xl:left-[0px] mt-[120px] lg:mt-[140px] xl:mt-[0px]  absolute object-contain" src={banner_back} />
                        <img className="xl:w-auto h-[201px] lg:h-[255px] xl:h-[481px] xl:mt-[0px] rounded-[18px] xl:rounded-[29px] left-[50px] md:left-[65px] absolute object-contain" src={banner_front} />                        
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}